import{gql as r}from"@apollo/client";const e=r`
  query checkUserAuthorizationByUserId($userId: Int!) {
    user {
      checkUserAuthorizationByUserId(userId: $userId)
    }
  }
`;export{e as CHECK_USER_AUTHORIZATION_BY_USER_ID_QUERY};
//# sourceMappingURL=useCheckUserAuthorizationByUserId.graphql.js.map
